import CitySEOHead from "@/components/feature/CitySEOHead";
import ApacheJunctionHeroSection from "./components/HeroSection";
import ApacheJunctionStickyNav from "./components/StickyNav";
import ApacheJunctionProcessingTimeSection from "./components/ProcessingTimeSection";
import ApacheJunctionServicesSection from "./components/ServicesSection";
import ApacheJunctionLocalAreaSection from "./components/LocalAreaSection";
import ApacheJunctionTravelTimingSection from "./components/TravelTimingSection";
import ApacheJunctionDestinationsSection from "./components/DestinationsSection";
import ApacheJunctionTestimonialsSection from "./components/TestimonialsSection";
import ApacheJunctionAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ApacheJunctionComparisonSection from "./components/ComparisonSection";
import ApacheJunctionMistakesSection from "./components/MistakesSection";
import ApacheJunctionHowItWorksSection from "./components/HowItWorksSection";
import ApacheJunctionFAQSection, { faqs } from "./components/FAQSection";
import ApacheJunctionHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import ApacheJunctionFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const apacheJunctionFaqs = faqs as { q: string; a: string }[];

const apacheJunctionServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function ApacheJunctionPage() {
  return (
    <>
      <CitySEOHead
        city="Apache Junction"
        state="Arizona"
        stateAbbr="AZ"
        route="/cities/apache-junction"
        title="Emergency Passport Apache Junction, AZ — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Apache Junction, AZ — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Pinal County snowbirds, retirees, RV travelers, and East Valley workers. Best price guarantee, 30-100% less than resellers."
        geoPlacename="Apache Junction, Arizona"
        geoPosition="33.4150;-111.5498"
        faqs={apacheJunctionFaqs}
        servicesSchema={apacheJunctionServices}
        statePageName="Arizona"
        statePageRoute="/states/arizona"
      />
      <div className="font-sans">
        <ApacheJunctionHeroSection />
        <ApacheJunctionStickyNav />
        <ApacheJunctionProcessingTimeSection />
        <ApacheJunctionServicesSection />
        <ApacheJunctionLocalAreaSection />
        <ApacheJunctionTravelTimingSection />
        <ApacheJunctionDestinationsSection />
        <ApacheJunctionTestimonialsSection />
        <ApacheJunctionAcceptanceFacilitiesSection />
        <ApacheJunctionComparisonSection />
        <ApacheJunctionMistakesSection />
        <ApacheJunctionHowItWorksSection />
        <ApacheJunctionFAQSection />
        <ApacheJunctionHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/apache-junction" state="AZ" />
        <ApacheJunctionFinalCTA />
      </div>
    </>
  );
}